/* Heritage polaroids — scattered photos anchored to the heritage media.
   Re-anchored 2026-06-23 INSIDE .heritage__media. It used to be appended to <body> and positioned
   by JS page-coords, which (a) escaped the html/body overflow-x:clip guard and pushed a ~5px
   horizontal page overflow that let the whole page pan sideways on mobile, and (b) raced the layout
   on cached loads so the photos landed in the wrong spot. Positions are now pure CSS relative to the
   media — deterministic and locked, no scroll/resize handlers, no parallax. Crafts
   only. Reversible: remove the <script> tag in layout/theme.liquid. */
(function () {
  function injectCSS() {
    if (document.getElementById('brave-heritage-css')) return;
    var CSS =
      /* overflow:visible so the polaroids can bleed past the media edges; the centre image keeps its
         own border-radius so it still reads as rounded. main{overflow-x:clip} contains any sideways
         bleed, so there is no page overflow. The .heritage CARD (overflow:hidden + 24px radius in the
         base theme) must also not clip, or the bleeding polaroids get cropped to the card's rounded
         shape — the small fixed offsets keep them inside the viewport regardless. */
      '.heritage{overflow:visible!important}' +
      '.heritage__media{position:relative!important;overflow:visible!important;border-radius:16px}' +
      '@media(min-width:900px){.heritage{grid-template-rows:auto!important;align-items:stretch!important}.heritage__media{align-self:stretch!important;aspect-ratio:auto!important;max-height:none!important;height:auto!important}}' +
      '.heritage__media>img{position:absolute!important;inset:0;width:100%!important;height:100%!important;object-fit:cover!important;border-radius:16px}' +
      /* MOBILE: put aspect-ratio + object-fit on the IMG in normal flow (the standard responsive
         pattern). Safari/Firefox mis-size a container that has aspect-ratio but whose only child is
         absolutely positioned (Chrome tolerates it) — that left the image oversized + overflowing. */
      '@media(max-width:899px){.heritage__media{aspect-ratio:auto!important;max-height:none!important;height:auto!important;min-height:0!important;align-self:start!important}.heritage__media>img{position:static!important;inset:auto!important;width:100%!important;height:auto!important;aspect-ratio:16/11!important;object-fit:cover!important;border-radius:16px}}' +
      /* overlay fills the media (its positioned parent) — no JS positioning, no scroll tracking */
      '#hp-overlay{position:absolute!important;inset:0!important;pointer-events:none;z-index:4}' +
      '.heritage-photo{position:absolute;aspect-ratio:3/4;background:#fff;padding:4px;border-radius:5px;box-shadow:0 6px 16px rgba(40,25,12,.30),0 1px 3px rgba(0,0,0,.22);pointer-events:none;overflow:hidden}' +
      '.heritage-photo img{width:100%;height:100%;object-fit:cover;border-radius:2px;display:block}' +
      /* horizontal offsets are small FIXED px (< the section gutter) so the polaroids stay fully
         inside the viewport at every width — visible, never clipped, and no horizontal overflow.
         Vertical bleed (top/bottom %) is kept for the scattered look (it does not clip sideways). */
      '.heritage-photo--1{top:-7%;left:-8px;width:clamp(96px,13vw,150px)}' +
      '.heritage-photo--2{bottom:-9%;right:-8px;width:clamp(112px,15vw,178px)}' +
      '.heritage-photo--3{top:34%;right:-8px;width:clamp(78px,11vw,122px)}' +
      /* MOBILE polaroids: pinned flush to the media edge (left/right:0, no negative bleed) so they
         can never spill off-screen regardless of how the browser sizes the media. */
      '@media(max-width:760px){.heritage-photo--3{display:none}.heritage-photo--1{top:-7%;left:0;bottom:auto;width:clamp(84px,24vw,120px)}.heritage-photo--2{top:-7%;right:0;bottom:auto;left:auto;width:clamp(96px,28vw,136px)}}';
    var st = document.createElement('style'); st.id = 'brave-heritage-css'; st.textContent = CSS; document.head.appendChild(st);
  }

  function applyHeritage() {
    var media = document.querySelector('.heritage__media');
    if (!media || media.querySelector(':scope > #hp-overlay')) return;
    var mimg = media.querySelector('img');
    var base = mimg && mimg.src ? mimg.src.replace(/[^/]+(\?.*)?$/, '') : '';
    if (!base) return;
    if (mimg) { mimg.removeAttribute('srcset'); mimg.src = base + 'heritage-feature.webp'; }
    var defs = [
      { cls: 'heritage-photo--1', img: 'heritage-poly-1.webp', rot: 6 },
      { cls: 'heritage-photo--2', img: 'heritage-poly-2.webp', rot: -5 },
      { cls: 'heritage-photo--3', img: 'heritage-poly-3.webp', rot: 7 }
    ];
    var ov = document.createElement('div'); ov.id = 'hp-overlay'; ov.setAttribute('aria-hidden', 'true');
    defs.forEach(function (p) {
      var d = document.createElement('div'); d.className = 'heritage-photo ' + p.cls;
      d.style.transform = 'rotate(' + p.rot + 'deg)';
      var im = document.createElement('img'); im.src = base + p.img; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
      d.appendChild(im); ov.appendChild(d);
    });
    media.appendChild(ov);
  }

  function run() { try { injectCSS(); applyHeritage(); } catch (e) {} }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
